module.exports = __webpack_public_path__ + "media/images/black_history_month/music-cad959796fb209a7c6f2869bbf9c58df.svg";